import React, { useEffect, useState } from "react";
import { Loader } from "semantic-ui-react";
import { IProxyUser } from "../interfaces/Global";
import BCDashboard from "../ui/BCDashboard";

interface IBWMakeAPayment {
    isGreaterThanMobile: boolean;
    isGreaterThanTablet: boolean;
    isSidebar: boolean;
    proxyUser: IProxyUser | undefined;
}

const BWMakeAPayment = ({
    isGreaterThanMobile,
    isGreaterThanTablet,
    isSidebar,
    proxyUser,
} : IBWMakeAPayment) => {
    const [isLoading, setIsLoading] = useState(true as boolean);

    useEffect(() => {
        setIsLoading(false);
    }, [proxyUser, setIsLoading]);

    const BWPaymentMethod = ({ paymentMethod }) => {
        const formatDetails = paymentMethod.details.map((detail) => {
            const [key, value] = detail.split(":");
            return (
                <div className="contact-info-text"><b>{key} :</b>{value}</div>
            );
        });

        return (
            <div className="contact-info-container">
                <div className="contact-info-header"><b>{paymentMethod.title.toLocaleUpperCase()}</b></div>
                {paymentMethod.message ? <div className="contact-info-text"><b>* {paymentMethod.message}</b></div> : <></>}
                {formatDetails}
            </div>
        );
    };

    const wirePayment = { 
        title: "Wire Payment to:",
        details: [
            "Account: Construction Loan Services II, LLC – 1019 39th Ave SE, Suite 220 Puyallup, WA 98374",
            "Bank: Bank of America",
            "ABA/Routing #: 026009593",
            "Account Number: 138110449973",
            "Reference: Loan Number",
        ]
    };

    const achPayment = { 
        title: "ACH Payment to:",
        details: [
            "Account Name: Construction Loan Services II LLC",
            "Address: 1019 39th Ave SE, Suite 220 Puyallup, WA 98374",
            "Bank: Bank of America",
            "ACH Routing Number: 125000024",
            "Account Number: 138110449973"
        ]
    };

    const mailPayment = { 
        title: "Mail Payment to:",
        details: [
            "Address: Construction Loan Services II, LLC – 1019 39th Ave SE, Suite 220 Puyallup, WA 98374",
            "Reference: Loan Number",
        ]
    };

    const creditCardPayment = { 
        title: "Pay by Credit Card:",
        details: [
            "Call to: 206-267-2650",
            "Extension: #3"
        ],
        message: "3% Credit Card fee will be charged"
    };

    const PaymentMethodLayout = [
        [
            {
                title: "Make A Payment",
                size: 16,
                content: <React.Fragment>
                    <BWPaymentMethod paymentMethod={wirePayment} />
                    <BWPaymentMethod paymentMethod={achPayment} />
                    <BWPaymentMethod paymentMethod={mailPayment} />
                    <BWPaymentMethod paymentMethod={creditCardPayment} />
                </React.Fragment>
            }
        ]
    ];

    return (
        <div className={(isGreaterThanTablet && isSidebar) ? "landing-page hide-sidebar" : "landing-page sidebar"}>
            {isLoading ? <Loader active inline="centered" size="big" /> : 
                <BCDashboard
                    DashboardLayout={PaymentMethodLayout}
                    isGreaterThanMobile={isGreaterThanMobile}
                />
            }
        </div>
    );
};

export default BWMakeAPayment;